"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNet = void 0;
const library_1 = require("../../core/library");
const loader_1 = require("./loader");
class GetNet extends library_1.Library {
    constructor(getNetUrl) {
        super('GetNet', new loader_1.GetNetLoader(getNetUrl));
    }
}
exports.GetNet = GetNet;
//# sourceMappingURL=index.js.map